<template>
  <div class="bg-white mt-20 tabs-palliative">
    <Banner />
    <div class="">
      <DisTab />
      <PartnerOrganization />
      <Faq />
      <Newsletter />
      <Disclaimer />
    </div>
    <div class="bge3ceff-opa">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Banner from "./neurology/Banner.vue";
import PartnerOrganization from "./components/PartnerOrganization.vue";
import DisTab from "./disorder/DisTab.vue";
import Tabs from "./neurology/Tabs.vue";
import Faq from "./components/Faq.vue";
import Symptoms from "./neurology/Symptoms.vue";
import Treatment from "./neurology/Treatment.vue";
import AboutType from "./neurology/AboutType.vue";
import HealthcareProvider from "./components/HealthcareProvider.vue";
import Newsletter from "./components/Newsletter.vue";
import Disclaimer from "./components/Disclaimer.vue";
import Footer from "../Footer.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import SideBlogs from "./components/SideBlogs.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    Banner,
    Tabs,
    DisTab,
    PartnerOrganization,
    HealthcareProvider,
    Faq,
    Treatment,
    AboutType,
    Symptoms,
    Newsletter,
    Disclaimer,
    Footer,
    DownloadApp,
    SideBlogs,
  },
  methods: {
    handleClick(tab) {
      console.log(tab.label);
      document.documentElement.scrollTop = 700;
    },
    async getFaqData() {
      let payload = {
        category: "Neurological Disorders",
        // subcategory: tab.label,
        active: true,
      };
      await this.$store.dispatch("medicalFaq/getFilteredMedicalFaq", payload);
    },
  },
  computed: {
    ...mapState("medicalFaq", ["FilteredMedicalFaq"]),
  },
  async mounted() {
    await this.getFaqData();
  },
};
</script>
